function detectAndHandleQRScan() {
  const urlParams = new URLSearchParams(window.location.search);
  const kioskOrderParam = urlParams.get("kiosk_order");
  const rebuildParam = urlParams.get("rebuild");

  console.log("Horizon QR Detection: kiosk_order parameter =", kioskOrderParam);
  console.log("Horizon QR Detection: rebuild parameter =", rebuildParam);

  if (kioskOrderParam === "1") {
    console.log("Horizon: QR Code detected! Setting cart attributes...");

    // First, rebuild the cart if rebuild parameter exists
    if (rebuildParam) {
      console.log("Horizon: Rebuilding cart from parameter:", rebuildParam);

      // Clear cart first
      fetch("/cart/clear.js", { method: "POST" })
        .then(() => {
          // Parse rebuild parameter (format: "variantID:quantity,variantID:quantity")
          const items = rebuildParam.split(",").map((item) => {
            const [variant_id, quantity] = item.split(":");
            return {
              id: parseInt(variant_id),
              quantity: parseInt(quantity),
            };
          });

          console.log("Horizon: Adding items to cart:", items);

          // Add items to cart WITH line item properties for AOD detection
          return fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              items: items.map((item) => ({
                ...item,
                properties: {
                  "Order Source": "kiosk",
                  _kiosk_order: "true",
                  _order_type: "kiosk",
                },
              })),
            }),
          });
        })
        .then((response) => response.json())
        .then((data) => {
          console.log("Horizon: Cart rebuild success:", data);

          // Now set cart attributes
          const attributeData = {
            attributes: {
              "Order Source": "kiosk",
            },
            note: "KIOSK ORDER (QR Scan) - " + new Date().toLocaleString(),
          };

          console.log("Horizon: Sending cart update with data:", attributeData);

          return fetch("/cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(attributeData),
          });
        })
        .then((response) => {
          console.log("Horizon: Cart update response status:", response.status);
          return response.json();
        })
        .then((data) => {
          console.log("Horizon: Cart update success:", data);
          // Verify the cart attributes were set
          return fetch("/cart.js");
        })
        .then((response) => response.json())
        .then((cart) => {
          console.log("Horizon: Cart verification:", cart);

          // Stop any kiosk polling since this is now a regular user session
          if (cartDrawerPolling) {
            clearInterval(cartDrawerPolling);
            cartDrawerPolling = null;
          }
          stopCartTimer();

          // Clean up URL and reload to show rebuilt cart (like Dawn theme)
          const newUrl = window.location.pathname;
          window.history.replaceState({}, document.title, newUrl);

          console.log("Horizon: Cart ready! Refreshing...");

          // Reload page to show rebuilt cart (same as Dawn)
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        })
        .catch((error) => {
          console.error("Horizon: Error in QR scan process:", error);
        });
    } else {
      // No rebuild parameter, just set attributes
      setTimeout(() => {
        const attributeData = {
          attributes: {
            "Order Source": "kiosk",
          },
          note: "KIOSK ORDER (QR Scan) - " + new Date().toLocaleString(),
        };

        console.log("Horizon: Sending cart update with data:", attributeData);

        fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(attributeData),
        })
          .then((response) => {
            console.log(
              "Horizon: Cart update response status:",
              response.status
            );
            return response.json();
          })
          .then((data) => {
            console.log("Horizon: Cart update success:", data);
            // Verify the cart attributes were set
            return fetch("/cart.js");
          })
          .then((response) => response.json())
          .then((cart) => {
            console.log("Horizon: Cart verification:", cart.attributes);
            // Remove the parameter from URL to clean it up
            const newUrl = window.location.href.replace(
              /[?&]kiosk_order=1/,
              ""
            );
            window.history.replaceState({}, document.title, newUrl);

            // Stop any kiosk polling since this is now a regular user session
            if (cartDrawerPolling) {
              clearInterval(cartDrawerPolling);
              cartDrawerPolling = null;
            }
            stopCartTimer();
          })
          .catch((error) => {
            console.error("Horizon: Error setting cart attributes:", error);
          });
      }, 500);
    }
  }
}

// Add kiosk mode detection with URL parameters
function detectKioskMode() {
  const urlParams = new URLSearchParams(window.location.search);
  const kioskParam = urlParams.get("kiosk");

  if (kioskParam === "1") {
    localStorage.setItem("kiosk_mode", "1");
    localStorage.setItem("kiosk_explicitly_set", "true");
  } else if (kioskParam === "0") {
    localStorage.removeItem("kiosk_mode");
    localStorage.removeItem("kiosk_explicitly_set");
  } else {
    if (!localStorage.getItem("kiosk_explicitly_set")) {
      localStorage.removeItem("kiosk_mode");
    }
  }
}

function applyBodyClass() {
  detectKioskMode();

  if (localStorage.getItem("kiosk_mode") === "1") {
    document.body.classList.add("kiosk-mode");
    window.isKioskMode = true;

    // Set cart attributes for kiosk mode
    const hiddenInputField = document.getElementById("order-source-attribute");
    if (hiddenInputField) {
      hiddenInputField.value = "kiosk";
    }

    // Also set via AJAX for QR checkout
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        attributes: {
          "Order Source": "kiosk",
        },
        note: "KIOSK ORDER - " + new Date().toLocaleString(),
      }),
    }).catch((error) =>
      console.error("Horizon: Error setting cart attributes:", error)
    );
  } else {
    document.body.classList.remove("kiosk-mode");
    window.isKioskMode = false;

    // STOP POLLING when not in kiosk mode to prevent console spam
    if (cartDrawerPolling) {
      clearInterval(cartDrawerPolling);
      cartDrawerPolling = null;
    }
    stopCartTimer();
  }
}

function updateCTAVisibility() {
  const qr = document.getElementById("Cart-QR-Code");
  const checkoutWrapper = document.getElementById("Cart-Checkout-Button");
  if (!qr || !checkoutWrapper) return;
  if (window.isKioskMode) {
    qr.style.display = "flex";
    checkoutWrapper.style.display = "none";
  } else {
    qr.style.display = "none";
    checkoutWrapper.style.display = "block";
  }
}

function maybeClearCartOnNewSession() {
  if (!window.isKioskMode) {
    sessionStorage.removeItem("kiosk_session_started");
    return;
  }

  // IMPORTANT: Don't clear cart if this is a rebuild operation (QR scan)
  const urlParams = new URLSearchParams(window.location.search);
  const rebuildParam = urlParams.get("rebuild");
  const kioskOrderParam = urlParams.get("kiosk_order"); // Add this check

  if (localStorage.getItem("kiosk_explicitly_set") !== "true") return;

  // Don't clear if this is ANY kind of QR scan operation
  if (
    !sessionStorage.getItem("kiosk_session_started") &&
    !rebuildParam &&
    !kioskOrderParam
  ) {
    // New session detected (but not a QR rebuild)
    fetch("/cart/clear.js", { method: "POST" })
      .then(function () {
        sessionStorage.setItem("kiosk_session_started", "1");
        location.reload();
      })
      .catch(function () {
        sessionStorage.setItem("kiosk_session_started", "1");
      });
  } else if (rebuildParam || kioskOrderParam) {
    // This is a QR rebuild or QR scan, just mark session as started
    sessionStorage.setItem("kiosk_session_started", "1");
  }
}

// timer state
let cartTimerInterval = null;
let cartTimerActive = false;
let timeLeft = 0;

function ensureTimerElement() {
  // Wait for .cart__ctas to exist before injecting the timer
  const tryInject = () => {
    const ctas = document.querySelector(".cart__ctas");
    if (!ctas) {
      setTimeout(tryInject, 100);
      return;
    }
    if (!document.getElementById("CartDrawer-Timer")) {
      const el = document.createElement("div");
      el.id = "CartDrawer-Timer";
      el.className = "cart__timer";
      el.style.display = "none";
      el.style.textAlign = "center";
      el.style.marginTop = "0.5rem";
      el.style.fontSize = "0.95rem";
      el.style.color = "var(--color-red, #FF0000)";
      ctas.appendChild(el);
    }
  };
  tryInject();
}

function updateTimerDisplay() {
  ensureTimerElement();
  const timerDisplay = document.getElementById("CartDrawer-Timer");
  console.log("updateTimerDisplay", { timeLeft, timerDisplay });
  if (!timerDisplay) return;
  if (timeLeft > 0) {
    const min = Math.floor(timeLeft / 60);
    const sec = (timeLeft % 60).toString().padStart(2, "0");
    timerDisplay.style.display = "block";
    timerDisplay.textContent = `Cart will clear in ${min}:${sec}`;
  } else {
    timerDisplay.textContent = "Cart has been cleared.";
    setTimeout(function () {
      timerDisplay.style.display = "none";
      location.reload();
    }, 2000);
  }
}

function startCartTimer(durationSeconds) {
  console.log("startCartTimer called", {
    cartTimerActive,
    timeLeft,
    durationSeconds,
  });
  if (!window.isKioskMode) return;
  if (!cartTimerActive) {
    timeLeft = durationSeconds || 300;
    cartTimerActive = true;
    ensureTimerElement();
    updateTimerDisplay();
    cartTimerInterval = setInterval(function () {
      timeLeft--;
      updateTimerDisplay();
      if (timeLeft <= 0) {
        clearInterval(cartTimerInterval);
        fetch("/cart/clear.js", { method: "POST" })
          .then(function () {
            updateTimerDisplay();
          })
          .catch(function () {
            const td = document.getElementById("CartDrawer-Timer");
            if (td) td.textContent = "Error clearing cart.";
          });
      }
    }, 1000);
  } else {
    updateTimerDisplay();
  }
}

function stopCartTimer() {
  clearInterval(cartTimerInterval);
  cartTimerActive = false;
  timeLeft = 0;
  const timerDisplay = document.getElementById("CartDrawer-Timer");
  if (timerDisplay) timerDisplay.style.display = "none";
}

// detection / polling
let cartDrawerPolling = null;
function pollCartDrawerOrCartStatus() {
  console.log(
    "pollCartDrawerOrCartStatus called, isKioskMode:",
    window.isKioskMode
  );
  if (!window.isKioskMode) {
    stopCartTimer();
    return;
  }

  fetch("/cart.js")
    .then((res) => res.json())
    .then((cart) => {
      console.log("cart.js result", cart);
      if (cart && cart.items && cart.items.length > 0) {
        startCartTimer();
        updateTimerDisplay();
      } else {
        stopCartTimer();
      }
    })
    .catch(() => stopCartTimer());
}

function setAODDetectionMethods() {
  console.log('Setting enhanced AOD detection methods...');
  
  // Method 1: Multiple form fields approach
  const forms = document.querySelectorAll('form');
  forms.forEach(form => {
    // Add multiple hidden fields with different naming conventions
    const fields = [
      { name: 'attributes[order_source]', value: 'kiosk' },
      { name: 'attributes[Order Source]', value: 'kiosk' },

      { name: 'note', value: 'KIOSK ORDER - ' + new Date().toISOString() }
    ];
    
    fields.forEach(fieldData => {
      // Remove existing field if present
      const existing = form.querySelector(`[name="${fieldData.name}"]`);
      if (existing) existing.remove();
      
      // Add new field
      const field = document.createElement('input');
      field.type = 'hidden';
      field.name = fieldData.name;
      field.value = fieldData.value;
      form.appendChild(field);
    });
  });
  
  // Method 2: Set URL parameters that persist through checkout
  const currentUrl = new URL(window.location.href);
  currentUrl.searchParams.set('order_source', 'kiosk');
  currentUrl.searchParams.set('kiosk_checkout', '1');
  window.history.replaceState({}, '', currentUrl.toString());
  
  // Method 3: Set cookie that checkout can read
  document.cookie = 'shopify_order_source=kiosk; path=/; SameSite=Lax';
  document.cookie = 'kiosk_checkout=true; path=/; SameSite=Lax';
  
  // Method 4: Try to force cart note through multiple methods
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      note: 'KIOSK ORDER - ' + new Date().toISOString(),
      attributes: {
        'order_source': 'kiosk',
        'Order Source': 'kiosk',

      }
    })
  });
  
  console.log('Enhanced AOD detection methods set');
}

function detectKioskForAOD() {
  const sessionKiosk = sessionStorage.getItem('aod_kiosk_order');
  const cookieKiosk = document.cookie.includes('aod_order_source=kiosk');
  const localKiosk = localStorage.getItem('aod_pending_kiosk_order');
  
  if (sessionKiosk || cookieKiosk || localKiosk) {
    console.log('AOD: Kiosk order detected via persistent methods');
    return true;
  }
  return false;
}

// checkout handler (idempotent)
if (!window._kioskCheckoutHandlerBound) {
  window._kioskCheckoutHandlerBound = true;
  document.addEventListener("click", function (e) {
    const target = e.target;
    if (!target) return;
    if (
      target.id === "checkout" ||
      (target.closest && target.closest("#Cart-Checkout-Button"))
    ) {
      if (window.isKioskMode) return;
      e.preventDefault();
      
      fetch("/cart.js")
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          // Check if this is a kiosk order and set AOD detection methods BEFORE checkout
          if (cart.attributes && cart.attributes["Order Source"] === "kiosk") {
            setAODDetectionMethods();
          }
          
          if (!cart || !cart.items || cart.items.length === 0) {
            const form =
              document.querySelector("form#cart-form") ||
              document.querySelector('form[action="/cart"]');
            if (form) form.submit();
            return;
          }
          const cartString = cart.items
            .map(function (item) {
              return item.variant_id + ":" + item.quantity;
            })
            .join(",");
          const redirectUrl = "/cart/" + cartString + "?kiosk=0&order_source=kiosk";
          localStorage.removeItem("kiosk_mode");
          localStorage.removeItem("kiosk_explicitly_set");
          document.body.classList.remove("kiosk-mode");
          window.location.href = redirectUrl;
        })
        .catch(function () {
          const form =
            document.querySelector("form#cart-form") ||
            document.querySelector('form[action="/cart"]');
          if (form) form.submit();
        });
    }
  });
}

function ensureFormInputFromCartAttributes() {
  // Check if we have kiosk attributes in the cart
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      if (cart.attributes && cart.attributes["Order Source"] === "kiosk") {
        const hiddenInputField = document.getElementById(
          "order-source-attribute"
        );
        if (hiddenInputField && !hiddenInputField.value) {
          hiddenInputField.value = "kiosk";
          console.log("Horizon: Set form input from cart attributes");
        }
      }
    })
    .catch((error) => console.error("Error checking cart attributes:", error));
}

// SINGLE init function - fixed
function init() {
  detectAndHandleQRScan(); // Add QR detection first
  applyBodyClass();
  updateCTAVisibility();
  maybeClearCartOnNewSession();
  ensureTimerElement();
  ensureFormInputFromCartAttributes();

  // ONLY start polling if we're in kiosk mode
  if (window.isKioskMode) {
    setTimeout(function () {
      pollCartDrawerOrCartStatus();
      cartDrawerPolling = setInterval(pollCartDrawerOrCartStatus, 500);
    }, 150);
  }
}

document.addEventListener("DOMContentLoaded", init);
document.addEventListener("shopify:section:load", function () {
  detectAndHandleQRScan(); // Add this
  applyBodyClass();
  updateCTAVisibility();
  maybeClearCartOnNewSession();
  ensureTimerElement();
  pollCartDrawerOrCartStatus();
});
document.addEventListener("cart:updated", function () {
  pollCartDrawerOrCartStatus();
});
document.addEventListener("shopify:section:reorder", function () {
  applyBodyClass();
  updateCTAVisibility();
});

const bodyObserver = new MutationObserver(function (mutations) {
  mutations.forEach(function (m) {
    if (m.attributeName === "class") {
      applyBodyClass();
      updateCTAVisibility();
    }
  });
});
bodyObserver.observe(document.documentElement || document.body, {
  attributes: true,
  attributeFilter: ["class"],
});

window.addEventListener("beforeunload", function () {
  stopCartTimer();
  if (cartDrawerPolling) clearInterval(cartDrawerPolling);
});
